import React from 'react'
import { ComponentExt } from 'util/reactExt'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { Menu, Table, Select, Tabs } from 'antd'
import styles from './index.scss'
import LineChart from 'containers/shared/LineChart'
import ICompareWithExampleChart from './ICompareWithExampleChart'
import ICompareWithToptenChart from './ICompareWithToptenChart'
import IAreaMostTable from './IAreaMostTable'
import Breadcrumb from 'components/Breadcrumb'

const TabPane = Tabs.TabPane

const Option = Select.Option
const currentYear = new Date().getFullYear()
const yearList = Array(currentYear - 2018 + 1)
  .fill(0)
  .map((_, i) => String(2018 + i))
  .reverse()

const studyMinsFormatter = min =>
  min ? Math.round((Number(min) / 60) * 100) / 100 : 0

const percentFormatter = percent =>
  percent ? Math.round(Number(percent) * 100 * 100) / 100 : 0

interface TeamDataProps extends RouteComponentProps<any> {}

class TeamData extends ComponentExt<TeamDataProps> {
  filedsTextMap = {
    sysStudyNum: '系统平均学习数量',
    teamStudyNum: '团队平均学习数量',
    sysStudyHour: '系统平均学习时长',
    teamStudyHour: '团队平均学习时长',
    sysStudyPercent: '系统平均视频完成度(%)',
    teamStudyPercent: '团队平均视频完成度(%)',
  }

  MenuRenderMap = {
    example: <ICompareWithExampleChart entityid={this.entityid} />,
    topten: <ICompareWithToptenChart entityid={this.entityid} />,
  }

  state = {
    loading: false,
    currentTablePage: 1,
    teamStudyData: [],
    teamStudyTrendData: [],
    currentComparison: 'topten',
  }

  componentDidMount() {
    this.fetchStudyData(currentYear)
    this.fetchStudyTrendData()
  }

  async fetchStudyData(year) {
    this.setState({ loading: true, myStudyData: [] })
    const { data } = await this.api.user.getTeamData(year, this.entityid)
    const teamStudyData = []

    for (const val of data) {
      teamStudyData.push({
        ...val,
        month: val.the_date.split('-')[1],
        study: studyMinsFormatter(val.study),
        finish_percent: percentFormatter(val.finish_percent),
      })
    }

    this.setState({
      teamStudyData,
    })

    this.setState({ loading: false })
  }

  async fetchStudyTrendData() {
    const { entity, sys } = await this.api.user.getTeamTrendData(this.entityid)
    const teamStudyTrendData = []
    const {
      sysStudyNum,
      sysStudyHour,
      teamStudyNum,
      teamStudyHour,
      sysStudyPercent,
      teamStudyPercent,
    } = this.filedsTextMap

    entity.forEach((val, key) => {
      teamStudyTrendData.push({
        month: val.the_date,
        [teamStudyNum]: Number(val.avg_articles),
        [teamStudyHour]: studyMinsFormatter(val.avg_study),
        [teamStudyPercent]: percentFormatter(val.finish_percent),
        [sysStudyNum]: Number(sys[key].avg_articles),
        [sysStudyHour]: studyMinsFormatter(sys[key].avg_study),
        [sysStudyPercent]: percentFormatter(sys[key].finish_percent),
      })
    })

    this.setState({
      teamStudyTrendData,
    })
  }

  handleChange = year => {
    this.fetchStudyData(year)
  }

  handleChangeComparisonClick = ({ key }) => {
    this.setState({
      currentComparison: key,
    })
  }

  handleChangeSectionClick = ({ key }) => {
    this.setState({
      currentSection: key,
    })
  }

  handleChangeTablePage = page => {
    this.setState({
      currentTablePage: page,
    })
  }

  get name() {
    return new URLSearchParams(this.props.location.search).get('name')
  }

  get entityid() {
    return new URLSearchParams(this.props.location.search).get('entityid')
  }

  // 团队数据报表
  renderTeamStudyTable = myStudyData => {
    const columns = [
      {
        title: '月份',
        dataIndex: 'month',
        className: 'columnCenter',
      },
      {
        title: '总学习时长(小时)',
        className: 'columnCenter',
        dataIndex: 'study',
      },
      {
        title: '视频学习数',
        className: 'columnCenter',
        dataIndex: 'articles',
      },
      {
        title: '视频完成度(%)',
        className: 'columnCenter',
        dataIndex: 'finish_percent',
        render: text => <span style={{ color: '#FF3C00' }}>{text}</span>,
      },
    ]
    return (
      <section>
        <h4 className={styles.chartTitle}>
          <span>{this.name}数据报表</span>
          <Select
            defaultValue={String(currentYear)}
            onChange={this.handleChange}
            style={{ width: 100, marginLeft: 24 }}
          >
            {yearList.map(y => (
              <Option key={y} value={y}>
                {y}
              </Option>
            ))}
          </Select>
        </h4>
        <Table
          loading={this.state.loading}
          columns={columns}
          dataSource={myStudyData}
          bordered
          pagination={{
            current: this.state.currentTablePage,
            defaultPageSize: 6,
            onChange: this.handleChangeTablePage,
            hideOnSinglePage: true,
          }}
        />
      </section>
    )
  }

  // 该团队的学习趋势图
  renderTeamStudyTrendChart = teamStudyTrendData => {
    return (
      <section>
        <h4 className={styles.chartTitle}>该团队的学习趋势图</h4>
        <LineChart
          data={teamStudyTrendData}
          filedsTextMap={this.filedsTextMap}
        />
      </section>
    )
  }

  render() {
    const { teamStudyData, teamStudyTrendData, currentComparison } = this.state
    return (
      <div className={styles.areaStudyData}>
        {this.entityid && (
          <Breadcrumb
            data={[
              { name: '学习力数据', url: '/usercenter/data/my' },
              { name: `${this.name}`, url: '' },
            ]}
          />
        )}
        {this.renderTeamStudyTrendChart(teamStudyTrendData)}
        {this.renderTeamStudyTable(teamStudyData)}
        <section>
          <Menu
            onClick={this.handleChangeComparisonClick}
            selectedKeys={[currentComparison]}
            mode="horizontal"
          >
            <Menu.Item key="example">该团队与榜样团队的对比</Menu.Item>
            <Menu.Item key="topten">该团队与前十团队的对比</Menu.Item>
          </Menu>
          {this.MenuRenderMap[currentComparison]}
        </section>
        <IAreaMostTable entityid={this.entityid} />
      </div>
    )
  }
}

export default withRouter(TeamData)
